const navBtnText = document.getElementById('navBtnText');

$('#navbar').on('show.bs.collapse', function () {
  navBtnText.innerText='Navigation zuklappen';
});

$('#navbar').on('hidden.bs.collapse', function () {
  navBtnText.innerText='Navigation ausklappen';
});
